module.exports = __webpack_public_path__ + "media/images/how_it_works/territorial-d98880b7c7763ea18eda230c3ef50c4e.svg";